const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="demo-radio-labels">
  `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.createRange(1, 3));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`i`] = __value__;
                    this.echo(`    <label class="demo-radio-label">
      `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/radio/radio.twig`, new Map([[`checked`, this.traceableMethod(this.getAttribute, 5, this.source)(this.env, context.get(`loop`), `first`, new Map([]), `any`, false, false, false)], [`name`, (((context.has(`disabled`) ? context.get(`disabled`) : null)) ? (`demo-radio-disabled`) : (`demo-radio-enabled`))]]), true, false, 4));
                    this.echo(`      Option `);
                    this.echo(this.env.getFilter('escape').traceableCallable(8, this.source)(...[this.env, context.get(`i`), `html`, null, true]));
                    this.echo(`
    </label>
  `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('i');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`</div>
`);
            }

            getTemplateName() {
                return `076bef85b8207ba463298ab17ca41035bc563cbbfe9680bb0d4eeee21cec9dd4`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `076bef85b8207ba463298ab17ca41035bc563cbbfe9680bb0d4eeee21cec9dd4`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '076bef85b8207ba463298ab17ca41035bc563cbbfe9680bb0d4eeee21cec9dd4');

let template = env.loadTemplate('076bef85b8207ba463298ab17ca41035bc563cbbfe9680bb0d4eeee21cec9dd4');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/radio/demo/with-label.twig", args: context }
     );
     return rendered;;
};